import "./PersonalTabEmptyState.scss";

import { Flex, Text } from "@fluentui/react-northstar";
import { Fragment } from "react";

import { EducationalContentAndVideosGuide } from "./EducationalContentAndVideosGuide";

export const PersonalTabEmptyState = () => {
  return (
    <Fragment>
      <div className="container">
        <Flex className="personal-tab-empty-state" hAlign="center" column gap="gap.large">
          <Flex hAlign="center" column gap="gap.small">
            <Text
              content="Welcome to Polly!"
              size="largest"
              weight="bold"
              className="personal-tab-empty-state__heading"
            />
            <Text
              size="larger"
              weight="regular"
              className="personal-tab-empty-state__sub-heading"
              content="Get started by adding Polly to a Chat, Meeting, or Team"
            />
          </Flex>
        </Flex>
      </div>

      <EducationalContentAndVideosGuide />
    </Fragment>
  );
};
